import request from '@/util/request'

export function productCompany(param) { //设备列表
	return request({
		url: `/product-s/product/company`,
		method: 'post',
		params: param, //$.param(data)
	});
}

export function productInstructionsCheck(data) { //根据指令查询产品是否支持
	return request({
		url: `/product-s/product/instructions/check`,
		method: 'post',
		data
	});
}


// WEBPACK FOOTER //
// ./src/api/product/index.js